/*
? First, let's import the interface that will describe the shape of our property object.
*/

import StateInterface from "../state-interface";

/*
& Now let's describe an initial state for the property object. This is the state that will be used when the app first fires up. Think of it like a placeholder.
*/

const property_data: StateInterface["property"] = {
	_id: "",
	slug: "",
	seo: {
		keywords: [""],
		meta_title: "",
		meta_description: "",
	},
	search_metrics: {
		search_string: "",
		search_string_delimiter: "",
		search_points: 0,
		location_coordinates: [],
		search_filter_hashes: [],
	},
	title: "",
	location: {
		title: "",
		pincode: "",
		country: "",
		state_or_province: "",
		city: "",
		about_location: [],
		about_location_pointers: [],
		about_location_image: {
			_id: "",
			file_id: "",
			url: "",
			caption: "",
			original_file_server_path: "",
		},
	},
	description: "",
	short_description: "",
	overview_pointers: [],
	builder: {
		name: " ",
		slug: "",
		description: "",
		year_est: 0,
		total_projects: 0,
		ongoing_projects: 0,
		completed_projects: 0,
		upcoming_projects: 0,
		logo: {
			_id: "",
			file_id: "",
			url: "",
			caption: "",
			original_file_server_path: "",
		},
	},
	price: {
		min: 0,
		max: 0,
		discounted: {
			min: 0,
			max: 0,
		},
		currency: "",
	},
	price_per_unit: {
		min: {
			ft: 0,
			mt: 0,
		},
		max: {
			ft: 0,
			mt: 0,
		},
		currency: "",
	},
	security_deposit: {
		min: 0,
		max: 0,
		negotiable: false,
		currency: "",
	},
	tags: [""],
	area: {
		label: "",
		enableLabel: false,
		land_area: {
			min: {
				ft: 0,
				mt: 0,
				acre: 0,
			},
			max: {
				ft: 0,
				mt: 0,
				acre: 0,
			},
		},
		super_built_up_area: {
			min: {
				ft: 0,
				mt: 0,
				acre: 0,
			},
			max: {
				ft: 0,
				mt: 0,
				acre: 0,
			},
		},
		carpet_area: {
			min: {
				ft: 0,
				mt: 0,
				acre: 0,
			},
			max: {
				ft: 0,
				mt: 0,
				acre: 0,
			},
		},
		karab_area: {
			min: {
				ft: 0,
				mt: 0,
				acre: 0,
			},
			max: {
				ft: 0,
				mt: 0,
				acre: 0,
			},
		},
	},
	plot_dimensions: [""],
	other_plot_dimensions: [""],
	config: {
		parameters: [
			{
				key: "",
				values: [""],
			},
		],
		label: "",
	},
	bhk: {
		min: 0,
		max: 0,
		label: "",
		enableLabel: false,
	},
	bathroom: {
		min: 0,
		max: 0,
		label: "",
		enableLabel: false,
	},
	balconies: {
		min: 0,
		max: 0,
		label: "",
		enableLabel: false,
	},
	floors: {
		min: 0,
		max: 0,
		label: "",
		enableLabel: false,
	},
	floor_no: {
		min: 0,
		max: 5,
		label: "",
		enableLabel: false,
	},
	no_of_seats: {
		min: 0,
		max: 0,
		label: "",
		enableLabel: false,
	},
	no_of_units: {
		min: 0,
		max: 0,
		label: "",
		enableLabel: false,
	},
	unit_facing: [""],
	land_facing: [""],
	cover_image: {
		_id: "",
		file_id: "",
		url: "",
		caption: "",
		original_file_server_path: "",
	},
	thumbnail_image: {
		url: "",
		caption: "",
	},
	images: [],
	pdf: "",
	status: "",
	assigned_to: [""],
	about_property: [""],
	about_property_image: {
		_id: "",
		file_id: "",
		url: "",
		caption: "",
		original_file_server_path: "",
	},
	amenities: [
		{
			id: "",
			label: "",
			icon: "",
		},
	],
	amenities_description: "",
	approvals: [
		{
			id: "",
			label: "",
			icon: "",
		},
	],
	vicinity: [
		{
			category: "",
			values: [
				{
					title: "",
					distance: 0,
				},
			],
		},
	],
	gmaps_embed_url: "",
	views: [],
	property_subtype: "",
	property_type: [],
	property_category: "",
	other_property_category: "",
	transaction_type: "",
	availability: [""],
	furnished: [""],
	possession_date: "",
	property_age: 0,
	related_services: [],
	show_contact_details: true,
	created_by: {
		is_business_profile: true,
		user_id: "",
		business_profile_id: "",
	},
	listedBy: "",
	flags: [],
	linked: true,
	linked_to: "",
	allow_copy: true,
	boost_information: {
		active: false,
		starts_at: "",
		ends_at: "",
		boost_id: "",
		total_amount: 0,
	},
	published: false,
	saved_content: [],
	is_public: false,
	is_ofb: true,
	deleted: false,
	deleted_at: "",
	created_at: "",
	updated_at: "",
	use_data_for_fine_tuning: false,
	manual_overview: "",
	simulated: false,
	is_overview_ai_generated: false,
	show_in_featured: false,
	employee_id: "",
	test: false,
	status_history: [],
	ad_text: "",
	commission_offered: 0,
	rera_number: "",
	regulatory_permit: {
		permit_number: "",
		issuing_authority: "",
	},
	broker_license: {
		permit_number: "",
		permit_name: "",
	},
	project_highlights: [],
	cta_section: {
		image: {
			_id: "",
			file_id: "",
			url: "",
			caption: "",
			original_file_server_path: "",
		},
	},
	faqs: [],
	floor_plans: [],
	price_sheet: {
		_id: "",
		file_id: "",
		url: "",
		caption: "",
		original_file_server_path: "",
	},
	landing_page_status: "pending",
	featured_property_index: 0,
	about_property_description: "",
	custom_brochure: {
		_id: "",
		file_id: "",
		url: "",
		caption: "",
		original_file_server_path: "",
	},
};

export const property = property_data;
export default property_data;
